import { SocketSelectionTypes } from './socket-selection-type';

export class SocketSelection {
    public constructor(
        public type: SocketSelectionTypes,
        public nodeId: string,
        public socketCode: number
    ) {}
}
